import React from "react";
import { Box, Button, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const TabNavigation = ({
  tabs,
  activeTab,
  onTabChange,
  showBadge = false,
  badgeCount = 0,
  badgeTab = null,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: theme.palette.background.default,
        // borderBottom: `5px solid ${theme.palette.grey[800]}`,
        px: { xs: 2, sm: 0 },
        pb: { xs: 1, sm: 0.5 },
        ml: 0,
        pt: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          overflowX: "auto",
          "&::-webkit-scrollbar": {
            height: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: theme.palette.grey[100],
            borderRadius: "2px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.grey[300],
            borderRadius: "2px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: theme.palette.grey[400],
          },
        }}
      >
        {tabs.map((tab) => (
          <Button
            key={tab.value}
            onClick={() => onTabChange(tab.value)}
            variant={activeTab === tab.value ? "contained" : "text"}
            sx={{
              width: { sm: "100px", md: "auto" },
              px: 1,
              py: 0,
              mt: 0,
              borderRadius: "12px 12px 12px 12px",
              fontWeight: 600,
              fontSize: { xs: "10px", sm: "12px" },
              textTransform: "none",
              position: "relative",
              backgroundColor:
                activeTab === tab.value
                  ? theme.palette.success.dark
                  : "transparent",
              color:
                activeTab === tab.value
                  ? theme.palette.primary.contrastText
                  : theme.palette.text.secondary,
              border:
                activeTab === tab.value
                  ? `1px solid ${theme.palette.grey[900]}`
                  : `1px solid ${theme.palette.grey[400]}`,
              // borderBottom:
              //   activeTab === tab.value
              //     ? "none"
              //     : `1px solid ${theme.palette.grey[200]}`,
              "&:hover": {
                backgroundColor:
                  activeTab === tab.value
                    ? theme.palette.success.main
                    : theme.palette.grey[50],
                color:
                  activeTab === tab.value
                    ? theme.palette.primary.contrastText
                    : theme.palette.text.primary,
              },
              "&:active": {
                transform: "translateY(1px)",
              },
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "normal", // allow text to wrap
              wordBreak: "break-word",
            }}
          >
            {tab.label}
            {showBadge && badgeTab === tab.value && badgeCount > 0 && (
              <Chip
                label={badgeCount}
                size="small"
                color="error"
                sx={{
                  minWidth: "20px",
                  height: "20px",
                  fontSize: "11px",
                  fontWeight: "bold",
                  backgroundColor: theme.palette.error.main,
                  color: theme.palette.error.contrastText,
                  "& .MuiChip-label": {
                    px: 1,
                  },
                }}
              />
            )}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default TabNavigation;
